/*
 * Copyright (c) 2022. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
export var Frequency;
(function (Frequency) {
    Frequency["Hourly"] = "h";
    Frequency["OneMinute"] = "min";
    Frequency["FiveMinutes"] = "5min";
    Frequency["TenMinutes"] = "10min";
    Frequency["FifteenMinutes"] = "15min";
    Frequency["ThirtyMinutes"] = "30min";
})(Frequency || (Frequency = {}));
export const weatherDataTypes = ['TMY', 'TimeSeries'];
export const weatherProbabilityOfExeedances = ['P50', 'P75', 'P90', 'P95', 'P99', 'NA'];
export const frequencyTdMap = {
    [Frequency.Hourly]: 60,
    [Frequency.OneMinute]: 1,
    [Frequency.FiveMinutes]: 5,
    [Frequency.TenMinutes]: 10,
    [Frequency.FifteenMinutes]: 15,
    [Frequency.ThirtyMinutes]: 30,
};
//# sourceMappingURL=weather.js.map